import { jsx as _jsx } from "react/jsx-runtime";
function MemorySizeConvertor(a, b = 2) {
    if (!+a)
        return '0 Bytes';
    const c = 0 > b ? 0 : b, d = Math.floor(Math.log(a) / Math.log(1024));
    const size = `${parseFloat((a / Math.pow(1024, d)).toFixed(c))} ${['Bytes', 'KB', 'MB', 'GB', 'TB'][d]}`;
    return _jsx("span", { children: size });
}
export default MemorySizeConvertor;
